import axios from "axios";
import React, { Component } from "react";
import LoaderRounded from "../LoaderRounded";
import RejectCollegeIDCardPopup from "../VoterVerification/VoterVerifyPopup";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Select from "react-select";
import { Redirect } from "react-router-dom";
import * as XLSX from "xlsx";
import LazyImage from "./LazyImage";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import ReactPaginate from "react-paginate";

export default class ApprovedVoterList extends Component {
    constructor() {
        super();
        this.state = {
            modal: false,
            name: "",
            yinId: "",
            firstName: "",
            lastName: "",
            modalInputName: "",
            mobileNumber: "",
            showModalPopup: false,
            buttonFalse: false,
            showSecondmodel: false,
            isShowSecondModelPopupClose: false,
            redirect: false,
            loader: false,
            userData: [],
            userCount: "",
            inProcessCount: 0,
            approvedCount: 0,
            rejectedCount: 0,
            showVoteDisputetpop: false,
            isDisputed: false,
            disabled: false,
            first_name: "Buddy",
            errorCandidate: "",
            last_name: "",
            start_time: "",
            end_time: "",
            deletedIndex: 0,
            rejectReason: [],
            disputedBY: "",
            selectedDate: "",
            approvedIndex: 0,
            CityData: [],
            CollageData: [],
            districtsLocal: JSON.parse(localStorage.getItem("districts")),
            selected_city: "",
            selectedStatus: "",
            college_code: "",
            currentPage: "",
            counts: "",
            totalPages: "",
            previousLimits: 1000,
            renderPageLimit: 50,
            selectedPage: 0,
            limitVal: 10,
            skip_value: 0,
            page_selected: 0,
            allpage: 0,
        };
        this.handleChange = this.handleChange.bind(this);
        this.storeRejectIDCardCandidateYinID =
            this.storeRejectIDCardCandidateYinID.bind(this);
        this.closeConfirmModal = this.closeConfirmModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.SetCollegeIDCardReason = this.SetCollegeIDCardReason.bind(this);
        this.selectDate = this.selectDate.bind(this);
        this.getMobileNumber = this.getMobileNumber.bind(this);
        this.getCandidateListDate = this.getCandidateListDate.bind(this);
        this.approvedVotes = this.approvedVotes.bind(this);
        this.getCandidateWithCity = this.getCandidateWithCity.bind(this);
        this.getCandidateWithCollege = this.getCandidateWithCollege.bind(this);
        this.getCandidateListByMobileNumber =
            this.getCandidateListByMobileNumber.bind(this);
        this.handleStatusOnChange = this.handleStatusOnChange.bind(this);
        this.log = this.log.bind(this);
        this.reApproveCandidate = this.reApproveCandidate.bind(this)
    }

    UNSAFE_componentWillMount() {
        let operator = JSON.parse(localStorage.getItem("operator"));
        let operatorEmailAddress = "";
        try {
            operatorEmailAddress = operator.email;
            this.setState({ operatorEmailAddress, isLoading: false });
        } catch (error) {
            console.error(error);
        }
        this.showCity();

        const storedDistrict = localStorage.getItem("searchedDistrict");
        const storedCollege = localStorage.getItem("searchedCollege");
        const storedStatus = localStorage.getItem("searchedStatus");
        localStorage.removeItem("searchedCollege");

        this.setState({
            selected_city: storedDistrict || "All",
            selectedStatus: storedStatus || "",
            college_code: ""
        });

        this.showCollage(storedDistrict ? storedDistrict : "");

        this.getCandidateList(
            storedDistrict ? storedDistrict : this.state.selected_city,
            storedStatus ? storedStatus : this.state.selectedStatus,
            storedCollege ? storedCollege : this.state.college_code,
            this.state.limit,
            this.state.skip
        );
    }

    // year dropdown code
    componentDidMount() {
        const currentYear = new Date().getFullYear();
        const initialYears = this.generateYears(2021, currentYear);
        this.setState({ years: initialYears });
    }

    generateYears(start, end) {
        const yearsArray = [];
        for (let year = end; year >= start; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    }

    handleCompleteYear = () => {
        const currentYear = new Date().getFullYear();
        this.setState((prevState) => ({
            years: [...prevState.years, currentYear + 1],
        }));
    };

    handlePageChange = (page) => {

        const selectedPage = page.selected;
        const skip = selectedPage * this.state.limitVal;

        this.setState({
            page_selected: selectedPage,
            skip_value: skip,
        });

        this.getCandidateList(
            this.state.selected_city,
            this.state.selectedStatus,
            this.state.college_code,
            skip,
            this.state.limitVal
        );
    };

    // Status onChange
    handleStatusOnChange(e) {
        this.setState({
            selectedStatus: e.target.value,
        });
        localStorage.setItem("searchedStatus", e.target.value);
        this.getCandidateList(
            this.state.selected_city,
            e.target.value,
            this.state.college_code,
            this.state.limit,
            this.state.skip
        );
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    getCandidateWithCity(event) {
        const city = event.target.value;
        localStorage.setItem("searchedDistrict", city);
        if (city === "All") {
            this.setState({
                selected_city: "All",
                CollageData: [],
                college_code: ""
            });
            return;
        }

        this.setState({
            selected_city: city,
            college_code: ""
        });

        this.showCollage(city);
        this.getCandidateList(
            city,
            this.state.selectedStatus,
            "",
            this.state.limit,
            this.state.skip
        );
    }

    getCandidateWithCollege(event) {
        const selectedCollegeCode = event.target.value;
        this.setState(
            { college_code: selectedCollegeCode },
            () => {
                this.getCandidateList(
                    this.state.selected_city,
                    this.state.selectedStatus,
                    selectedCollegeCode
                );
            }
        );
    }

    getCandidateList(selected_city, selected_status, college_code, skip = 0, limit = 10) {
        this.setState({
            loader: true,
        });

        let cityParam = "*";

        if (selected_city && selected_city !== "All") {
            cityParam = selected_city;
        } else if (this.state.CityData.length === 1) {
            cityParam = this.state.CityData[0];
        }

        axios.get(process.env.REACT_APP_APIURL +
            `/coordinator/user/college_id/approved/idcard?cities=${cityParam}&status=${selected_status ? selected_status : ""}&college_code=${college_code ? college_code : ""
            }&page=${skip}&limit=${limit}`
        )
            .then((response) => {
                const totalCount = response?.data?.count || 0;
                this.setState({
                    userData: response?.data?.data,
                    userCount: response?.data?.count,
                    inProcessCount: response?.data?.inProcessCount,
                    approvedCount: response?.data?.approvedCount,
                    rejectedCount: response?.data?.rejectedCount,
                    loader: false,
                    allpage: Math.ceil(totalCount / limit),
                });
            })
            .catch((error) => {
                this.setState({
                    loader: false,
                    noDisputeList: true,
                    buttonFalse: true,
                });
            });
    }

    getCandidateListDate() {
        this.setState({
            loader: true,
        });
        if (this.state.selectedDate === "") {
            alert("Please select date and time");
        } else {
            let dateData = {
                selectedDate: this.state.selectedDate,
            };
            axios.post(process.env.REACT_APP_APIURL +
                `/coordinator/user/college_id/unapproved/idcard/date`,
                dateData
            )
                .then((response) => {
                    this.setState({
                        userData: response?.data?.data,
                        userCount: response?.data?.count,
                        approvedCount: response?.data?.approvedCount,
                        rejectedCount: response?.data?.rejectedCount,
                        loader: false,
                    });
                })
                .catch((error) => {
                    this.setState({
                        loader: false,
                        noDisputeList: true,
                        buttonFalse: true,
                    });
                });
        }
    }

    // getCandidateListByMobileNumber() {
    //     this.setState({
    //         loader: true,
    //     });
    //     if (this.state.mobileNumber === "") {
    //         alert("Please enter mobile number");
    //     } else {
    //         let dateData = {
    //             mobile: this.state.mobileNumber,
    //         };
    //         axios.post(process.env.REACT_APP_APIURL +
    //             `/coordinator/user/college_id/unapproved/idcard/mobile`,
    //             dateData
    //         )
    //             .then((response) => {
    //                 this.setState({
    //                     userData: response?.data?.data,
    //                     userCount: response?.data?.count,
    //                     approvedCount: response?.data?.approvedCount,
    //                     rejectedCount: response?.data?.rejectedCount,
    //                     loader: false,
    //                 });
    //             })
    //             .catch((error) => {
    //                 this.setState({
    //                     loader: false,
    //                     noDisputeList: true,
    //                     buttonFalse: true,
    //                 });
    //             });
    //     }
    // }

    getCandidateListByMobileNumber() {
        this.setState({
            loader: true,
        });

        if (this.state.mobileNumber === "") {
            alert("Please enter mobile number");
        } else {
            let dateData = {
                mobile: this.state.mobileNumber,
            };

            axios.post(
                process.env.REACT_APP_APIURL +
                `/coordinator/user/college_id/unapproved/idcard/mobile`,
                dateData
            )
                .then((response) => {

                    const totalCount = response?.data?.count || 0;

                    this.setState({
                        userData: response?.data?.data,
                        userCount: totalCount,
                        approvedCount: response?.data?.approvedCount,
                        rejectedCount: response?.data?.rejectedCount,
                        loader: false,
                        allpage: Math.ceil(totalCount / this.state.limitVal),
                        page_selected: 0
                    });
                })
                .catch((error) => {
                    this.setState({
                        loader: false,
                        noDisputeList: true,
                        buttonFalse: true,
                    });
                });
        }
    }

    downloadUserListPDF = async () => {
        try {

            this.setState({ loader: true });

            const selected_city = this.state.selected_city;

            let cityParam = "*";

            if (selected_city && selected_city !== "All") {
                cityParam = selected_city;
            } else if (this.state.CityData.length === 1) {
                cityParam = this.state.CityData[0];
            }
            const response = await axios.get(
                process.env.REACT_APP_APIURL +
                `/coordinator/create-pdf/userlist?cities=${cityParam}&status=APPROVED`
            );
            const pdfLink = response.data;

            if (pdfLink) {
                window.open(pdfLink, "_blank");
            }

            this.setState({ loader: false });

        } catch (error) {
            console.log(error);
            this.setState({ loader: false });
        }
    };

    storeRejectIDCardCandidateYinID(yinID) {
        localStorage.setItem("dispute_candidate_id", yinID);
    }

    isShowPopup = (status, yin_id, indexSelected) => {
        this.setState({
            showModalPopup: true,
            disabled: true,
            yinId: yin_id,
            deletedIndex: indexSelected,
        });
    };

    isClosePopup = () => {
        this.setState({ showModalPopup: false });
    };

    isShowVoteDisputetpop = (status) => {
        this.setState({ showVoteDisputetpop: true });
    };

    closeConfirmModal = () => {
        this.setState({ showModalPopup: false });
    };

    disableButton = () => {
        this.setState({
            disabled: !this.state.disabled,
        });
    };

    handleSubmit() {
        this.setState({
            showModalPopup: false,
        });
        let nominateUserId = {
            yin_id: this.state.yinId,
            verification_status: false,
            verification_reject_reason: this.state.rejectReason,
        };
        axios.post(process.env.REACT_APP_APIURL +
            `/coordinator/user/college_id/verified_status/reject`,
            nominateUserId
        )
            .then((response) => {
                let datas = this.state.userData?.filter(
                    (e, i) => i !== this.state.deletedIndex
                );
                this.setState({ userData: datas });
                this.log("IMAGE_REJECTED", this.state.yinId, "REJECTED");
            })
            .catch((error) => {
                console.log(error);
            });
    }

    approvedVotes(yin_id, approvedIndex) {
        this.setState({
            showModalPopup: false,
        });
        let nominateUserId = {
            yin_id: yin_id,
            verification_status: true,
        };
        axios.put(process.env.REACT_APP_APIURL +
            `/coordinator/user/college_id/verified_status/approved`,
            nominateUserId
        )
            .then((response) => {
                let datas = this.state.userData?.filter((e, i) => i !== approvedIndex);
                this.setState({ userData: datas });
                this.log("IMAGE_VERIFIED", yin_id, "VERIFIED");
            })
            .catch((error) => {
                console.log(error);
            });
    }

    SetCollegeIDCardReason = async (rejectReasonConfirm) => {
        if (this.state.rejectReason.includes(rejectReasonConfirm)) {
        } else {
            this.state.rejectReason.push(rejectReasonConfirm);
        }
    };

    selectDate(event) {
        this.setState({
            selectedDate: event.target.value,
        });
    }

    getMobileNumber(event) {
        this.setState({
            mobileNumber: event.target.value,
        });
    }

    async log(type, user, id) {
        let operatorData = JSON.parse(localStorage.getItem("operator"));
        let operator = operatorData.email;
        let params = {
            type,
            user,
            id,
            operator,
        };
        try {
            await axios.post(process.env.REACT_APP_APIURL + `/audit/ops/log`, params);
        } catch (error) {
            console.log("failed to log", JSON.stringify(params));
        }
    }


    showCity() {
        let districts = JSON.parse(localStorage.getItem("districts"));

        if (Array.isArray(districts) && districts[0] !== "*") {

            if (districts.length === 1) {
                const city = districts[0];
                this.setState({
                    CityData: districts,
                    selected_city: city
                }, () => {

                    this.showCollage(city);
                    this.getCandidateList(city, "", "");
                });

            } else {
                this.setState({
                    CityData: districts,
                    selected_city: "All",
                    CollageData: []
                }, () => {

                    this.getCandidateList("All", "", "");

                });

            }

        } else {
            axios.get(process.env.REACT_APP_APIURL + `/address/city/MH`)
                .then((response) => {
                    const cityNames = response.data.map(e => e.name);
                    this.setState({
                        CityData: cityNames,
                        selected_city: "All",
                        CollageData: []
                    }, () => {
                        this.getCandidateList("All", "", "");
                    });

                });
        }
    }

    showCollage(city) {
        let citydata = city;
        axios.get(process.env.REACT_APP_APIURL + `/college/district/${citydata}`)
            .then((response) => {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    this.setState({
                        CollageData: response.data,
                    });
                } else {
                    // this.setState({
                    //   CollageData: [],
                    // });
                }
            })
            .catch((error) => {
                console.log("error in showCity", error);
            });
    }

    reApproveCandidate() {
        this.setState({
            redirect: true,
        });
    }

    render() {
        let cities;
        if (this.state.districtsLocal?.length > 0 && this.state.districtsLocal[0] !== "*") {
            cities = this.state.CityData?.map((e, key) => {
                return (
                    <option key={key} value={typeof e === "object" ? e.name : e}>
                        {typeof e === "object" ? e.name : e}
                    </option>
                );
            });

        } else {
            cities = this.state.CityData?.map((e, key) => {
                return (
                    <option key={key} value={e.name}>
                        {e.name}
                    </option>
                );
            });
        }
        let CollegeList;
        CollegeList = this.state.CollageData?.map((e, key) => {
            return (
                <option key={key} value={e.college_code}>
                    {e.college_name}
                </option>
            );
        });

        // get users district data
        const getDistData = localStorage.getItem("districts");
        const districtData = JSON.parse(getDistData);
        const getNewDistData = districtData?.map((itm, index) => {
            return itm;
        });

        if (this.state.redirect) {
            return (
                <Redirect to={{
                    pathname: "/re-approve"
                }}
                />
            );
        }

        // Excel export
        const downloadExcel = (customHeadings) => {
            let dataSet = [];
            dataSet = customHeadings;
            const worksheet = XLSX.utils.json_to_sheet(dataSet);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, this.state.userData[0].college_name + " " + "VoterIDCardList.xlsx");
            // setSheetLoader(false);
        };

        const CustomExcel = () => {
            // setSheetLoader(true);
            const customHeadings =
                this.state.userData !== undefined && this.state.userData.length > 0
                    ? this.state.userData.map((data, index) => ({
                        Id: index + 1,
                        Name: data.first_name + " " + data.last_name ?? "-",
                        College_Name: data.college_name ?? "-",
                        VoterIdCardStatus: data.isVoterIdCardStatus ?? "-"
                    }))
                    : "";
            downloadExcel(customHeadings);
        };

        return (
            <>
                <Sidebar />
                <div className="main">
                    <div className="topbar">
                        <Navbar title="Approved Voter List" />
                    </div>

                    <div className="container">

                        <div className="mt-3 mb-3">
                            <h3 className="text-center" style={{ fontWeight: "600" }}>
                                Voter College ID Card List
                            </h3>
                            <div className="d-flex mt-3 justify-content-end">
                                <h6 className="mt-2 mr-2">Approved:</h6>
                                <h6
                                    style={{
                                        display: "flex",
                                        borderRadius: "80px",
                                        padding: "10px",
                                        margin: "0 15px",
                                        backgroundColor: "#FFFB00",
                                        alignItems: "center",
                                    }}
                                >
                                    {this.state.approvedCount}
                                </h6>
                            </div>
                        </div>
                        <div className="mx-auto border">
                            <Row md={12} className="mx-4 mx-sm-0 mt-3 mb-3">
                                <Col md={4}>
                                    <label>Select by District</label>
                                    <select
                                        name="city"
                                        value={this.state.selected_city}
                                        className="btn dropdown-toggle w-100"
                                        style={{ backgroundColor: "#003147", color: "white" }}
                                        onChange={this.getCandidateWithCity}
                                    >
                                        {this.state.CityData.length > 1 && (
                                            <option value="All">All</option>
                                        )}

                                        {cities}
                                    </select>
                                </Col>


                                <Col md={4}>
                                    <label>Select by College</label>
                                    <select
                                        name="city"
                                        value={this.state.college_code}
                                        className="btn dropdown-toggle w-100"
                                        style={{ backgroundColor: "#003147", color: "white" }}
                                        onChange={this.getCandidateWithCollege}
                                    >
                                        <option value="">All College</option>
                                        {CollegeList}
                                    </select>
                                </Col>

                                <Col md={4}>
                                    <label>Search by Mobile</label>
                                    <div className="d-flex">
                                        <input
                                            type="number"
                                            className="form-control me-2"
                                            placeholder="Enter mobile number"
                                            onChange={this.getMobileNumber}
                                        />
                                        <Button
                                            onClick={this.getCandidateListByMobileNumber}
                                            style={{ backgroundColor: "#003147", color: "white" }}
                                        >
                                            <Icon.Search />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <Row className="mx-1">
                            <Col md={12} className="mt-4">
                                <div className="d-flex justify-content-end">
                                    <Button
                                        onClick={this.downloadUserListPDF}
                                        className="excelBtn"
                                        style={{ backgroundColor: "#003147", color: "white" }}
                                    >
                                        <Icon.BoxArrowDown className="me-2" />
                                        Export
                                    </Button>
                                </div>
                            </Col>
                        </Row>


                        {this.state.loader ? (
                            <LoaderRounded />
                        ) : this.state.userData.length > 0 ? (

                            <Container className="mt-4">

                                {this.state.userData.map((user, index) => (

                                    <Row
                                        key={index}
                                        className="p-4 p-md-3 border rounded-3 mb-5"
                                        style={{ backgroundColor: "#ffffef" }}
                                    >

                                        {/* LEFT SIDE PROFILE */}

                                        <Col md={3} className="text-center my-auto">

                                            <LazyImage
                                                src={
                                                    user?.profile_image[0]
                                                        ? user?.profile_image[0]
                                                        : require("../../Assets/images/noidcard.jpg").default
                                                }
                                                alt="Profile"
                                                style={{ borderRadius: "60px", width: "65px", height: "65px" }}
                                            />

                                            <p style={{ fontWeight: "500", marginBottom: "4px" }}>
                                                {user.first_name} {user.last_name}
                                            </p>

                                            <p style={{ fontSize: "12px" }}>{user.mobile}</p>

                                            <p style={{ fontSize: "12px" }}>{user.college_name}</p>

                                            <div style={{ fontSize: "10px" }}>Card Status</div>

                                            <p className="btn btn-sm border mb-2" style={{ fontWeight: "700" }}>
                                                {user?.isVoterIdCardStatus}
                                            </p>

                                        </Col>


                                        {/* RIGHT SIDE IMAGES */}

                                        <Col md={9}>

                                            <Row className="justify-content-center align-items-center">

                                                <Col md={6} className="text-center">

                                                    <h6>College ID Card</h6>

                                                    <LazyImage
                                                        src={
                                                            user?.college_id
                                                                ? user?.college_id
                                                                : require("../../Assets/images/noidcard.jpg").default
                                                        }
                                                        alt="College ID Card"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "320px",
                                                            objectFit: "contain",
                                                            borderRadius: "12px",
                                                        }}
                                                    />

                                                </Col>


                                                <Col md={6} className="text-center">

                                                    <h6>Government ID Card</h6>

                                                    <LazyImage
                                                        src={
                                                            user?.government_id[0]
                                                                ? user?.government_id[0]
                                                                : require("../../Assets/images/noidcard.jpg").default
                                                        }
                                                        alt="Government ID Card"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "320px",
                                                            objectFit: "contain",
                                                            borderRadius: "12px",
                                                        }}
                                                    />

                                                </Col>

                                            </Row>

                                        </Col>

                                    </Row>

                                ))}

                            </Container>

                        ) : (

                            <h5 style={{ textAlign: "center", marginTop: "20px" }}>
                                No Record Found...
                            </h5>

                        )}

                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={this.state.allpage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageChange}
                            containerClassName={"pagination justify-content-center"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    </div>


                    <RejectCollegeIDCardPopup
                        showModalPopup={this.state.showModalPopup}
                        closeModal={this.closeConfirmModal}
                        onPopupCloseMain={this.isClosePopup.bind(this)}
                        handleSubmit={this.handleSubmit}
                        rejectCollegeIdCardReason={this.SetCollegeIDCardReason}
                    />

                </div>

            </>
        );
    }
}
